// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__Uauly","md":"Avatar_md__i0g2s","avatarText":"Avatar_avatarText__Nj-i5"};